import {
  createSlice,
  isFulfilled,
  isPending,
  isRejected,
} from '@reduxjs/toolkit';

import { RootState } from './appStore';

interface ActionMeta {
  arg?: {
    endpointName?: string;
  };
}

const EXCLUDED_URL = 'getLogsDatesByMachinery';

export const appSlice = createSlice({
  name: 'app',
  initialState: {
    isLoading: false as boolean,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addMatcher(isPending, (state, action) => {
        const meta = action.meta as ActionMeta;
        if (meta.arg?.endpointName !== EXCLUDED_URL) {
          state.isLoading = true;
        }
      })
      .addMatcher(isFulfilled, (state, action) => {
        const meta = action.meta as ActionMeta;
        if (meta.arg?.endpointName !== EXCLUDED_URL) {
          state.isLoading = false;
        }
      })
      .addMatcher(isRejected, (state, action) => {
        const meta = action.meta as ActionMeta;
        if (meta.arg?.endpointName !== EXCLUDED_URL) {
          state.isLoading = false;
        }
      });
  },
});

export const selectIsLoading = (state: RootState) => state.app.isLoading;
